const splide = new Splide(".splide", {
  autoplay: true, // 自動再生
  type: "loop", // ループさせる
  perPage: 3, // 3枚表示
  focus: 0, // ページネーション数がスライド数になる
  pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
  pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
  interval: 3000, // 自動再生の間隔
  speed: 2000, // スライダーの移動時間
}).mount();

